import * as React from 'react';
import {Route, RouteComponentProps, Switch, withRouter} from 'react-router';
import SalesSupplierSummary from './SalesSupplierSummary';
import SalesSupplierDetails from './SalesSupplierDetails';
import SalesCustomerDetails from './SalesCustomerDetails';
import SalesCustomerSummary from './SalesCustomerSummary';
import i18n from '../../../../locale/i18n';
import {GUARD_ISCUSTOMER, GUARD_ISSUPPLIER, GUARD_PREMIUM_OR_ADMIN} from '../../routes';
import {NavLink} from 'react-router-dom';
import {Card, Grid, Icon} from 'semantic-ui-react';
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";
import SalesSupplierArticleSummary from "./article/SalesSupplierArticleSummary";
import SalesSupplierArticleDetails from "./article/SalesSupplierArticleDetails";

const t = i18n.t.bind(i18n);

interface PageProps extends RouteComponentProps<{}> {
}

class SalesRoutes extends React.Component<PageProps, {}> {

  public render() {
    const match = this.props.match;
    return (
        <Switch>
          <Route path={`${match.path}/supplier/:konto/:markt`} component={SalesSupplierDetails}/>
          <Route path={`${match.path}/supplier`} component={SalesSupplierSummary} />
          <Route path={`${match.path}/supplier-article/:account/:sorteNr2/:farbeNr/:laenge`} component={SalesSupplierArticleDetails} />
          <Route path={`${match.path}/supplier-article`} component={SalesSupplierArticleSummary} />
          <Route path={`${match.path}/customer/:konto/:markt`} component={SalesCustomerDetails}/>
          <Route path={`${match.path}/customer`} component={SalesCustomerSummary} />
          <Route render={() => (
              <div className={"ui container"}>
                <AnalyticsTracking page="sales" />

            <Grid>
                <Grid.Row>
                    <Grid.Column width={"8"}>
                        <h3>{t("Route.Sales")}</h3>
                        {GUARD_ISSUPPLIER() && (
                            <Card as={NavLink} to={`${match.path}/supplier`}>
                                <Card.Content style={{textAlign: 'center'}}>
                                    <Icon name={"truck"} style={{size: '2em'}}/><br />
                                    {t("Route.SalesSupplier")}
                                </Card.Content>
                            </Card>
                        )}
                        {GUARD_ISCUSTOMER() && (
                            <Card as={NavLink} to={`${match.path}/customer`}>
                                <Card.Content style={{textAlign: 'center'}}>
                                    <Icon name={"shopping cart"} style={{size: '2em'}}/><br />
                                    {t("Route.SalesCustomer")}
                                </Card.Content>
                            </Card>
                        )}
                    </Grid.Column>
                    <Grid.Column width={"8"}>
                        {GUARD_ISSUPPLIER() && GUARD_PREMIUM_OR_ADMIN() && (
                        <>
                            <h3>{t("Route.SalesArticle")}</h3>
                            <Card as={NavLink} to={`${match.path}/supplier-article`}>
                                <Card.Content style={{textAlign: 'center'}}>
                                    <Icon name={"truck"} style={{size: '2em'}}/><br />
                                    {t("Route.SalesSupplier")}
                                </Card.Content>
                            </Card>
                        </>
                        )}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
          </div>
          )} />
        </Switch>
    );
  }
}

export default withRouter(SalesRoutes);